<script>
	import Home from './Home.svelte';
	import Hangman from './Hangman.svelte';
	import About from './About.svelte';
	export let game;
	let page = 'home';
    let current_language = 'lad';
    let current_game = '';

	let cfg = {
        "title": "Word Games",
        "text": {
            "games": "Games",
			"play" : 'Play!'
        }
    };

	async function getGame() {
		let url = `games/${current_language}-${current_game}.json`;
		console.log(url);
		const res = await fetch(url);
		const game_config = await res.json();

		if (res.ok) {
			game = game_config;
			//return config_received;
		} else {
			throw new Error("Error");
		}
	}

	function clickPlay() {
		console.log('clickPlay');
		console.log(current_language);
    	console.log(current_game);
		let promiseGame = getGame();
		if (current_game != '') {
			page = current_game;
		}
	}
	function gotoAbout() {
		console.log('goto About')
		page = 'about';
	}
	function gotoHome() {
		console.log('goto Home')
		page = 'home';
	}

</script>

<style>
	main {
	  text-align: center;
	  padding: 1em;
	  margin: 0 auto;
	}
</style>

<main>
{#if page=='home' }
   <Home {clickPlay} bind:cfg={cfg} bind:current_language={current_language} bind:current_game={current_game} {gotoAbout} />
{:else if page=='about'}
   <About {gotoHome} />
{:else if page=='hangman'}
   <Hangman {gotoHome} {cfg} {game} />
{/if}
</main>


  